export default __webpack_public_path__ + "static/media/database-plus.a7f904d0.svg";